import React from 'react';
import {useRef, useEffect, useState} from 'react';
import axios from 'axios';

// import './profilePageStyle.css';
import TelegramLogin from './telegramLogin/telegramLoginComp';

function ProfilePage() {
    const [profile, setProfile] = useState(null);

    const ref = useRef(null);

    useEffect(() => {
        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
          
            if (!match) return null; // Return null if cookie not found
      
            try {
              const rawValue = match.split("=")[1];
            //   console.log(`Raw cookie value for ${name}:`, rawValue);
              return decodeURIComponent(rawValue); // Properly decode it
            } catch (error) {
              console.error(`Error decoding cookie ${name}:`, error);
              return null; // Return null if decoding fails
            }
        }

        // Fetches the users profile by passing in loginToken
        const profileData = async() => {
            try {
                const loginToken = getCookie('data');
                // console.log(loginToken);

                const getProfile = await axios({
                    url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/profile/fetch`, 
                    method: 'POST',
                    headers: {
                        // ADDED Security Measure
                        //apiKey: 'qazwsxedcrfvvfrcdexswzaq',
                        // 'Access-Control-Allow-Origin': 'http://localhost:8080/api/auth/login'
                    },
                    data: {
                        loginToken: loginToken
                    }
                });

                setProfile(getProfile);
                // console.log(getProfile.data.user.user.telegramId);
            } catch (err) {
                console.log(err);
            }
        }

        profileData();
    },[]);

    return(
        <>
        <div className='spacer'></div>
        <div className='spacer'></div>
        <article className='profile-panel flex column flex-nowrap justify-content-start align-items-start bg-color-background color-foreground padding-sm border rounded margin-t-sm margin-b-sm'>
            <section className='profile-title font-3xs color-foreground padding-sm border-bottom width-100p'>
                <h1 className='h1'>Your Profile</h1>
            </section>
            <section className='profile-body flex row flex-nowrap justify-content-cntr align-items-cntr padding-sm'>
                <section className='profile-section-left flex column flex-nowrap justify-content-start align-items-start'>
                    <span className='profile-data padding-b-sm'><b>First Name: </b></span>
                    <span className='profile-data padding-b-sm'><b>Last Name: </b></span>
                    <span className='profile-data padding-b-sm'><b>Email: </b></span>
                    <span className='profile-data padding-b-sm'><b>Username: </b></span>
                    <span className='profile-data padding-b-sm'><b>Date of Birth: </b></span>
                    <span className='profile-data padding-b-sm'><b>Mobile Number: </b></span>
                    <span className='profile-data padding-b-sm'><b>Telegram: </b></span>
                </section>
                {profile ? 
                <section className='profile-section-right flex column flex-nowrap justify-content-start align-items-start margin-l-sm'>
                    <span className='profile-data padding-b-sm'>{profile.data.user.user.firstName}</span>
                    <span className='profile-data padding-b-sm'>{profile.data.user.user.lastName}</span>
                    <span className='profile-data padding-b-sm'>{profile.data.user.user.email}</span>
                    <span className='profile-data padding-b-sm'>{profile.data.user.user.username}</span>
                    <span className='profile-data padding-b-sm'>{profile.data.user.user.dateOfBirth ? profile.data.user.user.dateOfBirth : "N/A"}</span>
                    <span className='profile-data padding-b-sm'>{profile.data.user.user.mobileNumber ? profile.data.user.user.mobileNumber : "N/A"}</span>
                    <span className='profile-data padding-b-sm'>{profile.data.user.user.telegramId !== '0' ? "Connected" : <TelegramLogin />}</span>
                </section>
                : 
                <div className='loader'></div>}
            </section>
        </article>
        <div className='spacer'></div>
        </>
    );
}

export default ProfilePage;